import * as React from 'react'

import { cn } from '~/styled'

import { useCarousel } from './Carousel'
import { CarouselSlideGapContext, toSlideGapClass } from './CarouselSlider'

export const CarouselSlide = ({
  children,
  className,
  index,
  ...rest
}: React.PropsWithChildren<
  { index: number } & React.HTMLAttributes<HTMLDivElement>
>) => {
  const { selectedIndex } = useCarousel()
  const gap = React.useContext(CarouselSlideGapContext)
  const isSelected = selectedIndex === index

  return (
    <div
      role="option"
      aria-selected={isSelected}
      // min-w-0 so basis-full wins over the content's min-content size and
      // the slide never outgrows the slider viewport
      className={cn('min-w-0', 'basis-full', 'shrink-0', className)}
      {...rest}
    >
      {/* padding to create the gap between slides; gap="none" for full-bleed */}
      <div
        className={cn('flex items-center justify-center', toSlideGapClass[gap])}
      >
        {children}
      </div>
    </div>
  )
}
